import L from 'leaflet';

export default new L.Icon({
  iconUrl: '/icons/gas-station.svg',
  iconRetinaUrl: '/icons/gas-station.svg',
  iconAnchor: [0, 0],
  popupAnchor: [10, -5],
  iconSize: [20, 20],
});